import { useContext } from 'react';
import useSWR from 'swr';
import { configurationContext } from '../contexts';
import { getUrl } from '../utils';
async function fetchLocalization(baseUrl, url, options) {
  var _translations$locale;
  var locale = options.lang;
  var _await$getUrl = await getUrl(baseUrl, url, options),
    translations = _await$getUrl.Translations;
  return {
    locale: locale,
    translations: (_translations$locale = translations[locale]) !== null && _translations$locale !== void 0 ? _translations$locale : {}
  };
}
export function useLocalizationQuery() {
  var _useContext = useContext(configurationContext),
    isDev = _useContext.isDev,
    staticApiUrl = _useContext.staticApiUrl,
    token = _useContext.token,
    tenant = _useContext.tenant,
    lang = _useContext.lang;
  var url = isDev ? '/applications/personalMenu/localization' : "applications/personalMenu/tenants/".concat(tenant, "/localization?lang=").concat(lang);
  return useSWR(url, async function () {
    return fetchLocalization(staticApiUrl, url, {
      token: token,
      tenant: tenant,
      lang: lang,
      isDev: isDev
    });
  });
}